import { RRule } from 'shared/lib/rrule';
import { HabitSchedule } from 'shared/types/habit-schedule';

export const getScheduleInterval = (schedule: HabitSchedule) => {
  if (schedule.frequency) {
    return 1;
  }

  const rrule = RRule.fromString(schedule.rrule.format);
  return Math.max(1, rrule.origOptions.interval ?? 1);
};
